<template>
  <v-footer
    
    background-color="black"
    height="100px" 
    font-size="6"
    style="font-size:6px; background-color:black; "
    
  >
    <div class="pa-3 tinytext">
      &copy; {{ new Date().getFullYear() }} Galeon Software - Grupo CMC. All
      rights reserved.
    </div>
    <v-spacer></v-spacer>

    <div class="tinytext overline text-left">
      <label class="tinytext text-left" >
        
        1. Responsable: COGNICASE MANAGEMENT CONSULTING, S.L.<br />
        2. Finalidad y legitimación: Necesitamos usar tus datos para
        identificarte como usuario y darte acceso a los servicios y
        funcionalidades que ofrecemos a nuestros usuarios registrados. Estaremos
        legitimados por la ejecución de las condiciones de uso de la web.<br />
        3. Destinatarios: Contratamos a proveedores dentro y fuera de la Unión
        Europea que nos dan soporte en el servicio y mantenimiento de la
        plataforma, y lo hacemos con garantías apropiadas y guardando la
        seguridad de tus datos.<br />
        4. Derechos: Tienes derecho a acceder, rectificar o suprimir tus datos,
        además de otros derechos, como detallamos en la información
        adicional.<br />
        5. Información adicional: Para más información, consulta nuestra
        Política de Privacidad
      </label>
    </div>
  </v-footer>
</template>
<script>
import { mapGetters } from "vuex";

export default {
  computed: {
    ...mapGetters({
      fixedFooter: "fixedFooter",
      footer: "showFooter",
      navFooterScheme: "navFooterScheme"
    })
  }
};
</script>
<style scoped>
.tinytext {
  text-align: left;
  color: #ffb529
}
</style>
